export default "__VITE_ASSET__BgkSj3ZC__"